export default __webpack_public_path__ + "static/media/old - Training & Competition Day flyer.8af2244e.pdf";